import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  connectToMyDesktop,
  useSelectIsMyDesktopDeletePending,
  useSelectIsMyDesktopStartPending,
  useSelectIsMyDesktopStopPending
} from 'Courses/data';
import { useAppDispatch } from 'Store';
import { openExternalUrl } from 'Utils/redirects';

import { ConnectToDesktopButton } from './ConnectToDesktopBase';

type Props = {
  courseId: string;
  disabled?: boolean;
  isHighlighted: boolean;
  isMinimized: boolean;
};

export const ConnectToMyDesktopButton = ({
  courseId,
  disabled,
  isHighlighted,
  isMinimized
}: Readonly<Props>) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const isMyDesktopStartPending = useSelectIsMyDesktopStartPending(courseId);
  const isMyDesktopStopPending = useSelectIsMyDesktopStopPending(courseId);
  const isMyDesktopDeletePending = useSelectIsMyDesktopDeletePending(courseId);
  const redirectToDesktop = (desktopLink: string) => openExternalUrl(desktopLink);

  const shouldNotRedirectToNewTab = true;

  const connectToDesktop = () =>
    dispatch(connectToMyDesktop(courseId)).then(response => {
      const newLink = (response?.payload as any)?.myDesktop?.link;

      if (!shouldNotRedirectToNewTab && newLink) {
        redirectToDesktop(newLink as string);
      }
    });

  return (
    <ConnectToDesktopButton
      buttonText={t('Connect')}
      onConnectToDesktopClick={connectToDesktop}
      disabled={disabled}
      isDesktopStartPending={isMyDesktopStartPending}
      isDesktopStopPending={isMyDesktopStopPending}
      isDesktopDeletePending={isMyDesktopDeletePending}
      isHighlighted={isHighlighted}
      isMinimized={isMinimized}
    />
  );
};
